<template>
  <div class="equipament-photos-main">
    <Toast :style="{ width: $isMobile() ? '100vw' : '' }" />
    <Dialog
      id="'dialog-equipament-photos'"
      :visible.sync="show"
      :style="{ width: $isMobile() ? '100vw' : '40vw', position: 'relative' }"
      v-bind:class="[{ 'p-dialog-maximized': $isMobile() }]"
      :modal="true"
      :closable="false"
      :header="'Assinaturas de confirmação'"
    >
      <Loading
        :active.sync="loading"
        :isFullPage="false"
        :zIndex="9000"
      ></Loading>
      <div class="p-fluid p-formgrid p-grid">
        <Message severity="error" v-if="!clientSignature || !profileSignature">
          <p>
            <span v-if="!clientSignature">- Assinatura do cliente em falta</span><br>
            <span v-if="!profileSignature">- A sua assinatura em falta</span>
          </p>
        </Message>

        <Button
          label="Ver assinatura cliente"
          icon="pi pi-eye"
          class="p-mb-2"
          :class="clientSignature ? 'p-button-success' : 'p-button-warning'"
          @click.prevent="showClientSignature = true"
        />

        <Button
          label="Ver a sua assinatura"
          icon="pi pi-eye"
          :class="profileSignature ? 'p-button-success' : 'p-button-warning'"
          @click.prevent="showProfileSignature = true"
        />
      </div>
      <template #footer>
        <Button
          v-if="service"
          :disabled="!clientSignature || !profileSignature"
          :label="'Gerar Relatório'"
          icon="pi pi-sync"
          class="p-button-success"
          @click="generateReport"
        />
        <Button
          label="Fechar"
          icon="pi pi-times"
          class="p-button-danger"
          @click="close"
        />
      </template>
    </Dialog>
    <DialogClientSignatureReport
      :show="showClientSignature"
      :taskId="task_id"
      @close="closeClientSignature"
      @saveSignature="savedClientSignature" />

    <DialogProfileSignature
      :show="showProfileSignature"
      @close="closeProfileSignature"
      @saveSignature="closeProfileSignature" />

  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import supportService from "../../services/support.service";
import UserService from "../../services/user.service"
import DialogClientSignatureReport from "./DialogClientSignatureReport.vue";
import DialogProfileSignature from "../profile/DialogProfileSignature.vue";

export default {
  name: "SignaturePadReport",
  props: ["show", "service"],
  components: {
    Loading,
    DialogClientSignatureReport,
    DialogProfileSignature
  },
  watch: {
    async show() {
      if (this.show === true) {
        this.task_id = this.service.id;
        await this.loadSignatures()

        if (!this.clientSignature || !this.profileSignature) {
          this.showClientSignature = true
        }
      } else {
        this.reset();
      }
    },
  },
  data() {
    return {
      loading: false,
      task_id: null,
      showClientSignature: false,
      showProfileSignature: false,
      clientSignature: null,
      profileSignature: null
    };
  },
  beforeDestroy() {
    this.showClientSignature = false
    this.showProfileSignature = false
    this.clientSignature = null
    this.profileSignature = null
  },
  methods: {
    reset() {
      this.task_id = null;
      return (this.loading = false);
    },
    close() {
      this.reset();
      return this.$emit("close");
    },
    async closeProfileSignature() {
      this.showProfileSignature = false
      this.loading = true;
      await this.getSignatureProfile()
      this.loading = false;
    },
    async closeClientSignature() {
      this.showClientSignature = false
      this.loading = true;
      await this.getInterventionTask()
      this.loading = false;
    },
    async savedClientSignature() {
      this.showClientSignature = false
      this.loading = true;
      await this.getInterventionTask()

      if (this.clientSignature && this.profileSignature) {
        this.$toast.add({
          severity: "info",
          summary: "Relatório pronto para gerar",
          detail: "Por favor, aguarde pela geração do relatório.",
          life: 5000,
        });

        this.generateReport()
      } else {
        this.$toast.add({
          severity: "warn",
          summary: "Assinaturas em falta",
          detail: "Por favor, verifique se ambas as assinaturas estão presentes.",
          life: 3000,
        });
      }

      this.loading = false;
    },
    generateReport() {
      this.loading = true;

      supportService
        .generateReport(this.task_id)
        .then(async (response) => {
          if (!response) {
            return this.$toast.add({
              severity: "error",
              summary: "Erro ao gerar relatório",
              detail: "Ocorreu um erro ao gerar relatório",
              life: 3000,
            });
          }

          this.$toast.add({
            severity: "success",
            summary: "Relatório registado",
            detail: "Relatório gerado com sucesso.",
            life: 5000,
          });

          this.loading = false;
          this.$emit("savedSignature", response);
        }).
        catch((response) => {
          this.$toast.add({
              severity: "error",
              summary: "Erro ao gerar relatório",
              detail: response,
              life: 3000,
            });
        }).finally(() => {
          this.loading = false
        });
    },
    async loadSignatures() {
      this.loading = true;
      await this.getInterventionTask()
      await this.getSignatureProfile()
      this.loading = false;
    },
    async getInterventionTask() {
      try {
        const response = await supportService.getInterventionTask(this.task_id);

        if (!response) {
          return this.$toast.add({
          severity: "error",
          summary: "Erro ao obter dados",
          detail: "Ocorreu um erro ao obter dados da tarefa",
          life: 3000,
          });
        }

        this.clientSignature = response.status.client_signature_data;
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: "Erro ao obter dados",
          detail: "Ocorreu um erro ao obter dados da tarefa",
          life: 3000,
        });
      }
    },
    async getSignatureProfile() {
      let signatureResponse = await UserService.getUserProfileSignature()
      this.profileSignature = signatureResponse.data
    }
  },
};
</script>
<style scoped>
.signature-box {
    margin-top: 10px;
    border: 2px solid #ccc;
    width: 100%;
    line-height: 0;
    overflow: hidden;
    border-radius: 4px;
}

.signature-box >>> canvas {
    width: 100% !important;
    height: auto !important;
}

.current-signature {
    width: 100%;
    max-height: 400px;
}

.current-signature img {
    max-width: 100%;
}
</style>
